// extracted by mini-css-extract-plugin
export default {"creditDataBox":"Info_creditDataBox__u-+5f","title":"Info_title__EdxHx","list":"Info_list__DAvFP"};